@if (isOpen()) {
  <div
    class="vb-lxp-panel overflow-auto"
    #panel
    #panelDragHandle="cdkDrag"
    cdkDrag
    animate.enter="enter-animation"
    animate.leave="leave-animation"
    [ngClass]="[panelClass(), !isPinned() && !disablePin() ? 'shadow-lg resize absolute' : '']"
    [cdkDragDisabled]="isPinned() || disablePin()"
    [cdkDragConstrainPosition]="constrainPosition"
  >
    <div
      class="panel-header-container relative"
      cdkDragHandle
      [ngClass]="[panelHeaderClass(), !isPinned() && !disablePin() ? 'drag-handle' : '']"
    >
      <ng-content select="[header]"></ng-content>
      <div class="panel-header-buttons">
        <ng-content select="[before-pin-action]"></ng-content>

        @if (!disablePin()) {
          <button class="panel-action-btn" (click)="onPinClicked()">
            @if (isPinned()) {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-pin-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A6 6 0 0 1 5 6.708V2.277a3 3 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354"
                />
              </svg>
            } @else {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-pin-angle-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a6 6 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707s.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a6 6 0 0 1 1.013.16l3.134-3.133a3 3 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146"
                />
              </svg>
            }
          </button>
        }
        <button
          class="panel-action-btn close-button"
          aria-label="Close panel"
          (click)="closePanel()"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>
    <div [ngClass]="panelBodyClass()">
      <ng-content select="[body]"></ng-content>
    </div>
  </div>
}
